import { element } from '@sections/cabinet/navigation';

export const LIST = 'cabinet:leads:list';
export const CREATE = 'cabinet:leads:create';
export const EDIT = 'cabinet:leads:edit';

const attract = true;

export const base = context => [
  element(context._('List'), LIST, 'notes'),
  element(context._('Add new'), CREATE, 'add', attract),
];

export const create = context => [
  element(context._('List'), LIST, 'notes'),
  element(context._('Add new'), CREATE, 'add'),
];
